document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".support-nav button");
  const contents = document.querySelectorAll(".faq-content");
  const questions = document.querySelectorAll(".faq-question");

  // Single "Expand All/Collapse All" button
  const expandCollapseButton = document.getElementById("expand-collapse-toggle");

  let clickedSearchItem = "";




  // Toggle function for expanding or collapsing all questions and nested FAQs
  function toggleExpandCollapse() {
    const isExpanded = expandCollapseButton.textContent === "Collapse All";

    if (isExpanded) {
      // Collapse all FAQ questions and nested FAQs
      questions.forEach((question) => {
        const answer = document.getElementById("faq-" + question.dataset.faq);
        const arrow = question.querySelector(".faq-arrow");
        if (question.classList.contains("activee")) {
          question.classList.remove("activee");
          answer.classList.add("hidden");
          arrow.innerHTML = '+';
          arrow.style.alignItems = "baseline";
        }
      });
      // Collapse nested FAQs
      document.querySelectorAll(".nested-faq-question").forEach((nestedFaq) => {
        const nestedAnswer = nestedFaq.nextElementSibling;
        const nestedArrow = nestedFaq.querySelector(".nested-faq-arrow");
        
        nestedFaq.classList.remove("activee");
        if (nestedAnswer) nestedAnswer.classList.add("hidden");
        if (nestedArrow) {
          nestedArrow.innerHTML = '+';
          nestedArrow.classList.remove('is-minus');
        }
      });
      // Update button text to "Expand All"
      expandCollapseButton.textContent = "Expand All";
    } else {
      // Expand all FAQ questions and nested FAQs
      questions.forEach((question) => {
        const answer = document.getElementById("faq-" + question.dataset.faq);
        const arrow = question.querySelector(".faq-arrow");
        if (!question.classList.contains("activee")) {
          question.classList.add("activee");
          answer.classList.remove("hidden");
          arrow.innerHTML = '-';
          arrow.style.alignItems = "center";
        }
      });
      // Expand nested FAQs
      document.querySelectorAll(".nested-faq-question").forEach((nestedFaq) => {
        const nestedAnswer = nestedFaq.nextElementSibling;
        const nestedArrow = nestedFaq.querySelector(".nested-faq-arrow");
        if (!nestedFaq.classList.contains("activee")) {
          nestedFaq.classList.add("activee");
          nestedAnswer.classList.remove("hidden");
          nestedArrow.innerHTML = '-';
          nestedArrow.classList.add('is-minus'); 
        }
      });
      // Update button text to "Collapse All"
      expandCollapseButton.textContent = "Collapse All";
    }
  }

  // Event listener for the "Expand/Collapse All" button
  expandCollapseButton.addEventListener("click", toggleExpandCollapse);

  // Existing logic for question toggling
  let activeQuestion = null;
  questions.forEach((question) => {
    question.addEventListener("click", function () {
      const answer = document.getElementById("faq-" + this.dataset.faq);
      const arrow = this.querySelector(".faq-arrow");
      const isActive = this.classList.contains("activee");

      // Toggle active state
      this.classList.toggle("activee");
      if (isActive) {
        answer.classList.add("hidden");
        arrow.innerHTML = '+';
        arrow.style.alignItems = "baseline";
        arrow.classList.remove('is-minus'); 
      } else {
        answer.classList.remove("hidden");
        arrow.innerHTML = '-';
        arrow.style.alignItems = "center";
        arrow.classList.add('is-minus');
      }

      // Set the current question as active
      if (!isActive) {
        activeQuestion = this;
      } else {
        activeQuestion = null;
      }
       updateExpandCollapseButtonText();
    });
  });

  // Nested accordion logic
  const allNestedFaqs = document.querySelectorAll(".nested-faq-question");
  allNestedFaqs.forEach(function (nestedFaq) {
    nestedFaq.addEventListener("click", function () {
      const nestedAnswer = nestedFaq.nextElementSibling; // Select the next sibling directly
      const arrow = nestedFaq.querySelector(".nested-faq-arrow");
      if (nestedAnswer && nestedAnswer.classList.contains("hidden")) {
        nestedAnswer.classList.remove("hidden");
        arrow.innerHTML = '-';
        arrow.classList.add('is-minus'); // Add this
      } else if (nestedAnswer) {
        arrow.innerHTML = '+';
        nestedAnswer.classList.add("hidden");
        arrow.classList.remove('is-minus'); 
      }
    });
  });
  function hideAllQuestions(element) {
    element.querySelectorAll(".faq-question").forEach(function (question) {
      question.classList.remove("activee");
      question.querySelector(".faq-arrow").textContent = "+";
      question
        .closest(".faq-item")
        .querySelector(".faq-answer")
        .classList.add("hidden");
    });
  }



    //move up button function
  //   document.querySelector(".support-moveUp button").addEventListener("click", () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth"
  //   });
  // });
  // check any faq/nested open
  function updateExpandCollapseButtonText() {
  const anyFaqOpen = document.querySelector(".faq-question.activee, .nested-faq-question.activee");
  expandCollapseButton.textContent = anyFaqOpen ? "Collapse All" : "Expand All";
  }
  
});


//move up button
//  document.addEventListener('DOMContentLoaded', function () {
//   const moveUpButton = document.querySelector('.support-moveUp');
//   const footer = document.querySelector('.hz__tov-footer');

//   function toggleMoveUpPosition() {
//     if (!moveUpButton || !footer) return;

//     const footerRect = footer.getBoundingClientRect();

//     if (footerRect.top < window.innerHeight) {
//       // Footer is visible
//       moveUpButton.classList.add('sticky-bottom');
//     } else {
//       // Footer is not visible
//       moveUpButton.classList.remove('sticky-bottom');
//     }
//   }

//   // Scroll-to-top behavior
//   if (moveUpButton) {
//     moveUpButton.addEventListener('click', function () {
//       window.scrollTo({
//         top: 0,
//         behavior: 'smooth'
//       });
//     });
//   }

//   // Listen for scroll and resize events
//   window.addEventListener('scroll', toggleMoveUpPosition);
//   window.addEventListener('resize', toggleMoveUpPosition);

//   // Initial check
//   toggleMoveUpPosition();
// });


 //mobile dropdown
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.getElementById('dropdownToggle');
  const menu = document.getElementById('dropdownMenu');

  toggle.addEventListener('click', function () {
    menu.classList.toggle('hidden');
    toggle.classList.toggle('active');
  });

  // Optional: close on outside click
  document.addEventListener('click', function (e) {
    if (!toggle.contains(e.target) && !menu.contains(e.target)) {
      menu.classList.add('hidden');
      toggle.classList.remove('active');
    }
  });

  // Optional: handle in-page scroll to section for dynamic tab buttons
  menu.querySelectorAll('button[data-tab]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.getAttribute('data-tab');
      const target = document.getElementById(tabId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
      menu.classList.add('hidden');
      toggle.classList.remove('active');
    });
  });
});
//chat button trigger


  document.addEventListener("DOMContentLoaded", function () {
    const gorgiasTrigger = document.querySelector(".gorgias_trigger");
    

    if (gorgiasTrigger) {
      
      gorgiasTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        if (window.GorgiasChat && typeof window.GorgiasChat.open === "function") {
          window.GorgiasChat.open();
        } else {
          console.warn("GorgiasChat API not ready");
        }
      });

    }
  });


//hide expand/collpase
  function toggleExpandButtonVisibility() {
    const visibleContent = document.querySelector('.faq-content:not(.hidden)');
    const expandWrapper = document.getElementById('expand-collapse-wrapper');

    if (!visibleContent || !expandWrapper) return;

    const contentType = visibleContent.dataset.contentType;
    const excludedTypes = ['contact', 'terms', 'privacy'];

    if (excludedTypes.includes(contentType)) {
      expandWrapper.style.display = 'none';
    } else {
      expandWrapper.style.display = 'block';
    }
  }
  
document.addEventListener("DOMContentLoaded", () => {
  const params = new URLSearchParams(window.location.search);
  const faqId = params.get("faq");

  if (!faqId) return;

  // Wait a bit in case content loads dynamically
  setTimeout(() => {
    // Try nested FAQ first
    let targetEl = document.querySelector(`.nested-faq-question[data-faq="${faqId}"]`);

    // Fallback to main FAQ
    if (!targetEl) {
      targetEl = document.querySelector(`.faq-question[data-faq="${faqId}"]`);
    }

    if (!targetEl) return;

    //  If nested, open parent first
    const parentQuestion = targetEl.closest(".faq-item")?.querySelector(".faq-question");
    if (parentQuestion && !parentQuestion.classList.contains("activee")) {
      parentQuestion.click();
    }

    //  Open target FAQ
    setTimeout(() => {
      if (!targetEl.classList.contains("activee")) {
        targetEl.click();
      }

      //  Scroll into view
      targetEl.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }, 150);
  }, 200);
});


  // Run on page load
  document.addEventListener('DOMContentLoaded', () => {
    toggleExpandButtonVisibility();

    // Update visibility when a tab is clicked
    document.querySelectorAll('[data-tab]').forEach(button => {
      button.addEventListener('click', () => {
        // Use a timeout if tab switch content is animated or delayed
        setTimeout(() => {
          toggleExpandButtonVisibility();
        }, 50);
      });
    });
  });
//move up button
  (function () {
  var container = document.getElementById('back-to-top-container');
  if(!container) return;

  function handleScroll() {
    if(window.scrollY > 400) {
      container.classList.add('is-visible');
    }
    else {
      container.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Run once immediately to catch mid-page reloads
  handleScroll();

  document.getElementById('back-to-top-btn').addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();